var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShare = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 10.6667C10.2987 10.6667 10 10.368 10 10C10 9.632 10.2987 9.33333 10.6667 9.33333C11.0347 9.33333 11.3333 9.632 11.3333 10C11.3333 10.368 11.0347 10.6667 10.6667 10.6667ZM2 6.66667C1.632 6.66667 1.33333 6.368 1.33333 6C1.33333 5.632 1.632 5.33333 2 5.33333C2.368 5.33333 2.66667 5.632 2.66667 6C2.66667 6.368 2.368 6.66667 2 6.66667ZM10.6667 1.33333C11.0347 1.33333 11.3333 1.632 11.3333 2C11.3333 2.368 11.0347 2.66667 10.6667 2.66667C10.2987 2.66667 10 2.368 10 2C10 1.632 10.2987 1.33333 10.6667 1.33333ZM10.6667 8C10.122 8 9.62867 8.22 9.26733 8.574L3.97733 6.22333C3.986 6.14933 4 6.076 4 6C4 5.924 3.986 5.85067 3.97733 5.77667L9.26733 3.426C9.62867 3.78 10.122 4 10.6667 4C11.7693 4 12.6667 3.10267 12.6667 2C12.6667 0.897333 11.7693 0 10.6667 0C9.564 0 8.66667 0.897333 8.66667 2C8.66667 2.076 8.68067 2.14933 8.68933 2.22333L3.39933 4.574C3.038 4.22 2.54467 4 2 4C0.897333 4 0 4.89733 0 6C0 7.10267 0.897333 8 2 8C2.54467 8 3.038 7.78 3.39933 7.426L8.68933 9.77667C8.68067 9.85067 8.66667 9.924 8.66667 10C8.66667 11.1027 9.564 12 10.6667 12C11.7693 12 12.6667 11.1027 12.6667 10C12.6667 8.89733 11.7693 8 10.6667 8Z",
    fill: "#42586E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share.a5f5aa6e.svg";
export { ForwardRef as ReactComponent };